import { TrackKind, TrackType } from '@24i/player-base';
import i18next from 'i18next';
import { isValid } from '@cospired/i18n-iso-languages';
const TRANSLATED_LANGUAGES_NS = 'translatedLanguages';
const countryIsoCodePattern = /[a-z]{2}-[A-Z]{2}/;
const supportedLanguages = {
    br: () => require('@cospired/i18n-iso-languages/langs/br.json'),
    de: () => require('@cospired/i18n-iso-languages/langs/de.json'),
    fi: () => require('@cospired/i18n-iso-languages/langs/fi.json'),
    id: () => require('@cospired/i18n-iso-languages/langs/id.json'),
    ja: () => require('@cospired/i18n-iso-languages/langs/ja.json'),
    ms: () => require('@cospired/i18n-iso-languages/langs/ms.json'),
    pl: () => require('@cospired/i18n-iso-languages/langs/pl.json'),
    ru: () => require('@cospired/i18n-iso-languages/langs/ru.json'),
    vi: () => require('@cospired/i18n-iso-languages/langs/vi.json'),
    cs: () => require('@cospired/i18n-iso-languages/langs/cs.json'),
    en: () => require('@cospired/i18n-iso-languages/langs/en.json'),
    fr: () => require('@cospired/i18n-iso-languages/langs/fr.json'),
    is: () => require('@cospired/i18n-iso-languages/langs/is.json'),
    lt: () => require('@cospired/i18n-iso-languages/langs/lt.json'),
    nl: () => require('@cospired/i18n-iso-languages/langs/nl.json'),
    pt: () => require('@cospired/i18n-iso-languages/langs/pt.json'),
    sv: () => require('@cospired/i18n-iso-languages/langs/sv.json'),
    zh: () => require('@cospired/i18n-iso-languages/langs/zh.json'),
    da: () => require('@cospired/i18n-iso-languages/langs/da.json'),
    es: () => require('@cospired/i18n-iso-languages/langs/es.json'),
    hu: () => require('@cospired/i18n-iso-languages/langs/hu.json'),
    it: () => require('@cospired/i18n-iso-languages/langs/it.json'),
    lv: () => require('@cospired/i18n-iso-languages/langs/lv.json'),
    no: () => require('@cospired/i18n-iso-languages/langs/no.json'),
    ro: () => require('@cospired/i18n-iso-languages/langs/ro.json'),
    th: () => require('@cospired/i18n-iso-languages/langs/th.json'),
    he: () => require('@cospired/i18n-iso-languages/langs/he.json'),
};
const addResourceBundle = (language) => {
    if (supportedLanguages[language]) {
        i18next.addResourceBundle(language, TRANSLATED_LANGUAGES_NS, supportedLanguages[language]());
    }
};
export const getAudioLabel = (channels) => {
    let label = '';
    switch (channels) {
        case 6:
            label = 'Dolby 5.1';
            break;
        case 8:
            label = 'Dolby 7.1';
            break;
        default:
            break;
    }
    return label ? ` (${label})` : '';
};
export const getTrackLabel = (track, tracks) => {
    var _a, _b, _c, _d;
    if (!track)
        return '';
    const lang = i18next.language || 'en';
    if (!i18next.hasResourceBundle(lang, TRANSLATED_LANGUAGES_NS)) {
        addResourceBundle(lang);
    }
    const trackLanguage = countryIsoCodePattern.test(track.language)
        ? track.language.split('-')[0]
        : track.language;
    let t = i18next.getFixedT(lang, TRANSLATED_LANGUAGES_NS);
    if (Intl && Intl.DisplayNames) {
        const laguageNames = new Intl.DisplayNames([lang], {
            type: 'language',
        });
        t = (localeString = '') => {
            if (localeString) {
                const lng = localeString === null || localeString === void 0 ? void 0 : localeString.split('languages.')[1];
                if (lng) {
                    return laguageNames.of(lng);
                }
            }
            return '';
        };
    }
    const emptyTrackLowerCase = TrackKind.Empty.toLowerCase();
    let numberOfTextTracksExcludingEmpty = 0;
    if (track.type === TrackType.Text) {
        numberOfTextTracksExcludingEmpty = tracks.filter((filteredTrack) => {
            var _a, _b;
            return ((_a = filteredTrack.kind) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== emptyTrackLowerCase &&
                ((_b = filteredTrack.id) === null || _b === void 0 ? void 0 : _b.toLowerCase()) !== emptyTrackLowerCase;
        }).length;
    }
    let label = '';
    if (isValid(trackLanguage) && track.type !== TrackType.Video) {
        label = t(`languages.${trackLanguage}`);
    }
    else if (isValid(track.label)) {
        label = t(`languages.${track.label}`);
    }
    else if (isValid(track.id)) {
        label = t(`languages.${track.id}`);
    }
    else if (track.type === TrackType.Audio && tracks.length === 1) {
        label = i18next.t('player.defaultAudioTrack');
    }
    else if (track.type === TrackType.Text && numberOfTextTracksExcludingEmpty === 1) {
        label = i18next.t('player.defaultAudioTrack');
    }
    else if (track.type === TrackType.Audio && tracks.length > 1) {
        const channelValues = [];
        tracks.forEach((trackChecked) => {
            const { channels } = trackChecked || {};
            if (channels && channelValues.indexOf(channels) === -1) {
                channelValues.push(channels);
            }
        });
        if (channelValues.length === tracks.length) {
            label = i18next.t('player.defaultAudioTrack');
        }
    }
    if (track.type === TrackType.Text &&
        (((_a = track.kind) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === emptyTrackLowerCase ||
            ((_b = track.id) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === emptyTrackLowerCase)) {
        return i18next.t('common.none');
    }
    if (track.type === TrackType.Text && label === '' && track.kind === TrackKind.Captions) {
        label = 'CC';
    }
    if (track.type === TrackType.Audio) {
        return `${label}${getAudioLabel(track.channels)}`;
    }
    return label || ((_d = (_c = track.label) !== null && _c !== void 0 ? _c : trackLanguage) !== null && _d !== void 0 ? _d : track.id);
};
//# sourceMappingURL=language.js.map